import { defineMessages } from 'react-intl';

export const modalFormMessages: {
	modalTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dataFormatHelperText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	requiredFieldsAsterisk: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dataFormatLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dataFormatClearControlLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tellUsAboutYourExperience: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tellUsAboutYourExperiencePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectDataFormatError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	submittedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	submittedDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	modalTitle: {
		id: 'import-feedback.feedback-modal.title',
		defaultMessage: 'Give feedback on imported content',
		description:
			'The text is shown as the heading of a modal dialog that prompts users to provide feedback on content that was imported into Confluence.',
	},

	dataFormatHelperText: {
		id: 'import-feedback.feedback-modal.data-format-helper-text',
		defaultMessage: 'Start typing to get a list of possible matches or press down to select.',
		description:
			'Helper text for data format select, located right below the data format select dropdown',
	},

	requiredFieldsAsterisk: {
		id: 'import-feedback.feedback-modal.required-fields-asterisk',
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'Explains that required feedback form fields are marked with an asterisk',
	},

	feedbackText: {
		id: 'import-feedback.feedback-modal.feedback-text',
		defaultMessage:
			'This content was imported from {source	}. Please let us know what issues you found below!',
		description:
			'Asks for feedback form and indicates the source of the imported content, located within the feedback form.',
	},
	dataFormatLabel: {
		id: 'import-feedback.feedback-modal.data-format-label',
		defaultMessage: 'Data formats with issues',
		description: 'Label for the dropdown menu to select which data format that needs improvement',
	},
	dataFormatClearControlLabel: {
		id: 'import-feedback.feedback-modal.data-format-clear-control-label',
		defaultMessage: 'Clear selected data format',
		description: 'Accessible text for the clear button in the dropdown menu',
	},
	tellUsAboutYourExperience: {
		id: 'import-feedback.feedback-modal.tell-us-about-your-experience',
		defaultMessage: 'Tell us about your experience',
		description:
			'The text is shown as a label above the text area input in the import feedback modal, prompting the user to describe their experience with the imported content.',
	},
	tellUsAboutYourExperiencePlaceholder: {
		id: 'import-feedback.feedback-modal.tell-us-about-your-experience-placeholder',
		defaultMessage: 'Please expand on what could be improved for this imported content.',
		description: 'Placeholder text for the feedback form text area',
	},

	feedbackButton: {
		id: 'import-feedback.feedback-modal.feedback-button',
		defaultMessage: 'Send Feedback',
		description: 'Text for button to submit feedback the user has entered within the feedback form',
	},

	closeButton: {
		id: 'import-feedback.feedback-modal.close-button',
		defaultMessage: 'Cancel',
		description: 'Text for button to close the modal & feedback form without submitting feedback',
	},
	selectDataFormatError: {
		id: 'import-feedback.feedback-modal.select-data-format-error',
		defaultMessage: 'Please select a data format',
		description: 'Error message displayed when the data format selection is empty',
	},
	submittedTitle: {
		id: 'import-feedback.feedback-modal.submitted-title',
		defaultMessage: 'Thanks!',
		description: 'Title within popup that appears after the user has submitted feedback',
	},

	submittedDescription: {
		id: 'import-feedback.feedback-modal.submitted-description',
		defaultMessage: 'Your valuable feedback helps us continually improve our products.',
		description: 'Description within popup that appears after the user has submitted feedback',
	},
});
